export default __webpack_public_path__ + "cac8a88187fffab6b601a6fb25a726f8.jpg";